import React, { Component } from 'react';
import "LIBRARY/Components/Periodicals/PeriodicalsOrJournals/importPeriodicals/importPeriodicals.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import CSVReader from 'react-csv-reader'
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import Select from 'react-select';
import * as XLSX from "xlsx";
import { toast } from 'react-toastify';

const papaparseOptions = {}

class ImportPeriodicals extends Component {
    constructor(props) {
        super(props)
        this.tableObject = {};
        this.myRef = React.createRef();
        this.state = {
            importPeriodicalModal: false,
            tabs: [
                { name: "Choose Excel File" },
                { name: "Start Import" }
            ],
            currentTab: 0,

            csvData: [],
            postPeriodicalDetailsArray: [],
            postPeriodicalHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                errors: [],
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
                verificationHistory: {}
            },

            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},
            fullScreen: false,

            errorMessageObjArray: [],
            preRequisiteFileName: 'Prerequisite Data.csv',

            preRequisiteArrayForPeriodicity: ['Daily', 'Weekly', 'Fortnightly', 'Monthly', 'Bi Monthly', 'Quarterly', 'Half yearly', 'Yearly', 'Triennial', 'Tri Annually'],

            //PreRequisite data
            preRequisiteCSVDataForFaculty: [
                { periodicity: '', category: '', department: '', publisher: '', accessionSeries: '' },
            ],

            preRequisiteData: [],
            GetStreamList: {},
            loadingStreamData: false,
            loadingYearData: false,
            loadingCategoryData: false,
            loadingAgengyData: false,
            loadingAgengyMOUData: false,
            academicYearList: {},
            academicYearSequence: [],
            dropDownstreamList: [],
            preRequisiteCSVHeadersForFaculty: [
                { label: "Periodicity", key: "periodicity" },
                { label: "Periodical Category", key: "category" },
                { label: "Department ", key: "department" },
                { label: "Publisher ", key: "publisher" },
                { label: "Accession Series ", key: "accessionSeries" },
            ],

            categoryList: {},
            preRequisiteHeaders: [],

            GetPublisherList: {},
            loadingPublisherData: false,
            searchPublisher: '',
            publisherPageIndex: 'all',
            publisherLimit: 'all',
            importPeriodicalLoading: false,
            iidPreRequisiteData: config.institute_id,
            iidImportPeriodical: config.institute_id,

            // prerequisite data
            GetResourceCategoryList: {},
            loadingResourceCategoryData: false,

            GetDepartmentList: {},
            loadingDepartmentData: false,

            accessionSeriesList: {},
            loadingAccessionSeriesData: false,

            publisherDataList: {},
            loadingPublisherDetails: false,


            // import periodical data
            ImportGetResourceCategoryList: {},
            loadingImportResourceCategoryData: false,

            ImportGetDepartmentList: {},
            loadingImportDepartmentData: false,

            ImportaccessionSeriesList: {},
            loadingImportAccessionSeriesData: false,

            ImportpublisherDataList: {},
            loadingImportPublisherDetails: false,
        }
    }

    componentDidMount() {
        // API Call for pre-requisite data
        this.apiCallToGetInstituteStreamList();  // department
        this.apiCallToGetAccessionSeries(); // accession series
        this.getPublisherList();  // publisher list
        this.apiCallToGetCategoryList(); // category list data

        // API Call for import periodical data
        // this.ImportGetLibraryResourceCategoryListWithBasicDetails();  // resource category
        // this.ImportapiCallToGetInstituteStreamList();  // department
        this.ImportapiCallToGetAccessionSeries(); // accession series
        this.ImportgetPublisherList();  // publisher list 

        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty
        let preRequisitePeriodicity = this.state.preRequisiteArrayForPeriodicity

        // For periodicity
        if (preRequisitePeriodicity.length > 0) {
            preRequisitePeriodicity.map((type, index) => {
                if (type != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].periodicity = type
                    } else {
                        preRequisiteData.push({ periodicity: type, category: '', department: '', publisher: '', accessionSeries: '' })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.isShowImportPeriodicalButton != prevProps.isShowImportPeriodicalButton && this.props.isShowImportPeriodicalButton == true) {
            this.openImportPeriodicalModal()
        } else if (this.props.isShowImportPeriodicalButton != prevProps.isShowImportPeriodicalButton && this.props.isShowImportPeriodicalButton == false) {
            this.closeImportPeriodicalModal()
        }
    }

    // API Call For Pre-Requisite START

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingDepartmentData: true,
        })
        let requestData = {
            "iid": this.state.iidPreRequisiteData
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let formattedData = Object.entries(apiResult).map(([sid, details]) => ({
                    sid,
                    name: details.stream_name
                }));

                this.setState({
                    GetDepartmentList: formattedData,
                    loadingDepartmentData: false,
                })
            } else {
                this.setState({
                    GetDepartmentList: {},
                    loadingDepartmentData: false,
                })
            }
        }
    }

    // API CALL METHOD TO GET CATEGORY LIST
    apiCallToGetCategoryList = async () => {
        this.setState({
            loadingResourceCategoryData: true
        });

        let requestData = {
            "iid": this.state.iidPreRequisiteData
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryPeriodicalCategoryList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetCategoryList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    GetResourceCategoryList: apiResult,
                    loadingResourceCategoryData: false,
                });

            } else {
                this.setState({
                    GetResourceCategoryList: {},
                    loadingResourceCategoryData: false
                });
            }
        }
    }

    // API CALL TO GET get publisher List 
    getPublisherList = async () => {
        this.setState({
            loadingPublisherDetails: true,
        })
        let requestData = {
            iid: this.state.iidPreRequisiteData,
            pageIndex: "all",
            limitPerPage: "all",
            searchPublisher: ""
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.name,
                }));

                this.setState({
                    publisherDataList: formattedData,
                    loadingPublisherDetails: false,
                })
            } else {
                this.setState({
                    loadingPublisherDetails: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeriesData: true });

        let requestData = {
            "iid": this.state.iidPreRequisiteData,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeriesData: false
                });
            }
        }
    }

    // API Call For Pre-Requisite END

    // API Call Import START

    // API CALL TO GET get Institute Stream List 
    ImportapiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingImportDepartmentData: true,
        })
        let requestData = {
            "iid": this.state.iidImportPeriodical
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.ImportapiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let formattedData = Object.entries(apiResult).map(([sid, details]) => ({
                    sid,
                    name: details.stream_name
                }));

                this.setState({
                    ImportGetDepartmentList: formattedData,
                    loadingImportDepartmentData: false,
                })
            } else {
                this.setState({
                    ImportGetDepartmentList: {},
                    loadingImportDepartmentData: false,
                })
            }
        }
    }

    // API CALL METHOD TO GET CATEGORY LIST
    ImportGetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingImportResourceCategoryData: true
        });

        let requestData = {
            "iid": this.state.iidImportPeriodical
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryPeriodicalCategoryList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.ImportGetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    ImportGetResourceCategoryList: apiResult,
                    loadingImportResourceCategoryData: false
                });

            } else {
                this.setState({
                    ImportGetResourceCategoryList: {},
                    loadingImportResourceCategoryData: false
                });
            }
        }
    }

    // API CALL TO GET get publisher List 
    ImportgetPublisherList = async () => {
        this.setState({
            loadingImportPublisherDetails: true,
        })
        let requestData = {
            iid: this.state.iidImportPeriodical,
            // isOrderByAscendingDisplayName: "true",
            pageIndex: this.state.publisherPageIndex,
            limitPerPage: this.state.publisherLimit,
            searchPublisher: this.state.searchPublisher
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.ImportgetPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.name,
                }));

                this.setState({
                    ImportpublisherDataList: apiResult.data,
                    loadingImportPublisherDetails: false,
                })
            } else {
                this.setState({
                    ImportpublisherDataList: {},
                    loadingImportPublisherDetails: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    ImportapiCallToGetAccessionSeries = async () => {
        this.setState({ loadingImportAccessionSeriesData: true });

        let requestData = {
            "iid": this.state.iidImportPeriodical,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.ImportapiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.seriestext,
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    ImportaccessionSeriesList: formattedMembers,
                    loadingImportAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingImportAccessionSeriesData: false
                });
            }
        }
    }

    // API Call Import END

    // Import PERIODICAL Modal Start From Here
    openImportPeriodicalModal = () => {

        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {

            this.setState({
                importPeriodicalModal: true
            })

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }

    }

    closeImportPeriodicalModal = () => {
        this.setState({
            importPeriodicalModal: false,
            currentTab: 0,

            csvData: [],
            postPeriodicalDetailsArray: [],
            postPeriodicalHeadersArray: [],
            selectedCSVFiles: {},
            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            verifiedData: [],
            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},

        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input-periodical");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        };

        this.props.closeImportModalForPeriodicals();
    }

    // OPEN FILE
    openFileInput = () => {
        // document.getElementById("react-csv-reader-input").click();
        document.getElementById("react-excel-reader-input-periodical").click();
    }

    // REMOVE SELECTED CSV FILE
    removeCSVFile = () => {
        this.setState({
            selectedCSVFiles: {},
            csvData: [],
            postPeriodicalDetailsArray: [],
            postPeriodicalHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            selectedCSVFiles: {},
            verifiedData: [],
        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input-periodical");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // Import PERIODICAL Modal
    importPeriodicalModal = () => {
        return (
            <>
                <div className={this.state.importPeriodicalModal ? 'modal fade show' : 'modal'} style={{ display: this.state.importPeriodicalModal ? "block" : 'none', visibility: this.state.importPeriodicalModal ? 'visible' : 'hidden' }}>
                    <div class="modal-dialog modal-lg--userdetails modal-dialog-centered" style={{ maxWidth: this.state.fullScreen ? '100vw' : '60vw', margin: this.state.fullScreen ? "0px auto" : "auto" }}>
                        <div class="modal-content modal-dialog-scrollable modal_content">
                            <div class="modal-header modal_header">
                                <h5 class="modal-title" style={{ textAlign: 'left' }} id="exampleModalLabel">Import Periodical Details</h5>
                                <span style={{ cursor: "pointer" }} onClick={() => {
                                    this.closeImportPeriodicalModal()
                                }}>
                                    <FontAwesomeIcon icon={['fas', 'times']} size={'md'} />
                                </span>
                            </div>
                            <div class="modal-body" style={{ maxHeight: this.state.fullScreen ? '100vh' : "80vh", height: this.state.fullScreen ? '100vh' : '80vh' }}>
                                <div className="">
                                    <div className="row">
                                        <div className="col">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="import-header">
                                                    {
                                                        this.state.tabs.map((item, index) => {
                                                            return (
                                                                <div className="tab-wrapper"><span className={this.state.currentTab == index ? "circle-tab" : "circle-tab-muted"}>{index + 1}</span><p className={this.state.currentTab == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p></div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                    this.setState({
                                                        fullScreen: !this.state.fullScreen
                                                    })
                                                }}>
                                                    {
                                                        this.state.fullScreen ?
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            ) :
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            )
                                                    }
                                                </button>
                                            </div>

                                            {
                                                this.state.currentTab == 0 && this.chooseFileComponent()
                                            }
                                            {
                                                this.state.currentTab == 1 && this.importCSVFileComponent()
                                            }

                                            <div className="import-footer">
                                                {
                                                    this.state.currentTab == 1 &&

                                                    <div style={{ width: '100%', margin: '0px 10px 0 0' }}>

                                                        {
                                                            <div className="d-flex align-items-center flex-wrap" style={{ display: this.state.loadingImportProcess ? '' : 'none !important' }}>
                                                                {
                                                                    <>
                                                                        <ProgressBar bgcolor={"#6a1b9a"} completed={this.state.importProgressSummary['completed']} failed={this.state.importProgressSummary['failed']} total={this.state.importProgressSummary['total']} pending={this.state.importProgressSummary['pending']} />
                                                                        <p className="mb-0 font-weight-bold" style={{ fontSize: 14 }}>Import Progress: {(this.state.importProgressSummary['total'] - this.state.importProgressSummary['pending'])} | {this.state.importProgressSummary['total']}</p>
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.currentTab == 0 && this.state.csvData.length > 0 && this.state.validations['isHeadersValid'] && (
                                                        <button type="button" className="btn import-btn" onClick={() => {
                                                            this.setState({
                                                                currentTab: 1
                                                            })
                                                        }}>
                                                            Proceed
                                                        </button>
                                                    )
                                                }
                                                {
                                                    this.state.currentTab == 1 && (
                                                        <>

                                                            {/* {
																this.state.validations['isVerified'] ?
																	<span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
																		<FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Verified
																	</span>
																	:
																	<button type="button" className="btn import-btn" disabled={this.state.validations['isVerified']} onClick={() => {
																		this.setState({
																			loadingVerificationProcess: true
																		}, () => {
																			this.validateCSVFileData()
																		})
																	}}>
																		Verify
																	</button>
															} */}

                                                            {
                                                                this.checkImportStatus() ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Imported Successfully
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <button type="button" className="btn import-btn" onClick={() => {

                                                                            let importProgressSummary = { completed: 0, failed: 0, total: this.state.postPeriodicalDetailsArray.length, pending: this.state.postPeriodicalDetailsArray.length }
                                                                            this.setState({
                                                                                loadingImportProcess: true,
                                                                                importProgressSummary
                                                                            }, () => {

                                                                                this.apiCallToImportPeriodicalDetails(0, this.state.importProgressSummary)
                                                                            })
                                                                        }

                                                                        }>
                                                                            Import
                                                                        </button>
                                                                    </>
                                                            }
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.importPeriodicalModal && <div className="modal-backdrop fade show"></div>}
            </>
        )
    }

    // export subscription details into excel format
    exportData = () => {
        // Define the CSV headers
        const headers = [
            "Title*", "Publisher", "ISSN Number", "Accession Series", "Accession Number", "Periodical Category", "Periodicity", "Department"
        ];

        // Adding sample hard-coded data
        const sampleData = [
            ["Sample Periodical 1", "Publisher", "1234-4567", "VM_S1", "1", "Science", "Yearly", "Computer Engineering, Electrical Engineering"],
        ];

        const fileName = 'Periodicals Details.xlsx';
        const rowData = [];

        // Loop through the resource data and generate rows for the table
        sampleData.map(data => {
            const row = [
                data[0] || '',
                data[1] || '',
                data[2] || '',
                data[3] || '',
                data[4] || '',
                data[5] || '',
                data[6] || '',
                data[7] || '',
            ];

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);

    };

    // download pre-requisite data in excel format
    exportPreRequisiteData = () => {
        // Define the CSV headers
        const headers = this.state.preRequisiteCSVHeadersForFaculty.map(header => header.label);
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty

        const fileName = 'PreRequisite_Periodicals_Details.xlsx';
        const rowData = [];

        // For Department
        if (Object.values(this.state.GetDepartmentList).length > 0) {
            Object.keys(this.state.GetDepartmentList).map((stream, index) => {
                let branch = this.state.GetDepartmentList[stream]
                if (branch != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].department = branch.name
                    } else {
                        preRequisiteData.push({ periodicity: '', category: '', department: branch.name, publisher: '', accessionSeries: '' })
                    }
                }
            })
        }

        // For categoryList
        if (Object.values(this.state.GetResourceCategoryList).length > 0) {
            Object.keys(this.state.GetResourceCategoryList).map((Id, index) => {
                let category = this.state.GetResourceCategoryList[Id]
                if (category != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].category = category.category_name
                    } else {
                        preRequisiteData.push({ periodicity: '', category: category.category_name, department: '', publisher: '', accessionSeries: '' })
                    }
                }
            })
        }

        // For publiser data
        if (Object.values(this.state.publisherDataList).length > 0) {
            Object.keys(this.state.publisherDataList).map((Id, index) => {
                let publiser = this.state.publisherDataList[Id]
                if (publiser != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].publisher = publiser.label
                    } else {
                        preRequisiteData.push({ periodicity: '', category: '', department: '', publiser: publiser.label, accessionSeries: '' })
                    }
                }
            })
        }

        // For accession series
        if (Object.values(this.state.accessionSeriesList).length > 0) {
            Object.keys(this.state.accessionSeriesList).map((Id, index) => {
                let accessionSeries = this.state.accessionSeriesList[Id]
                if (accessionSeries != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].accessionSeries = accessionSeries.label
                    } else {
                        preRequisiteData.push({ periodicity: '', category: '', department: '', publisher: '', accessionSeries: accessionSeries.label })
                    }
                }
            })
        }

        // Loop through the resource data and generate rows for the table
        preRequisiteData.forEach(resource => {
            const row = this.state.preRequisiteCSVHeadersForFaculty.map(header => {
                // Access each key dynamically from resource using the header key
                return resource[header.key] || ''; // If no value exists, return an empty string
            });

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);
    };

    // display excel data onchange of choose file
    handleExcelInput = (event) => {
        const file = event.target.files[0];

        const fileDetails = {
            name: file.name,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
            webkitRelativePath: file.webkitRelativePath,
            size: file.size,
            type: file.type
        };


        this.setState({
            selectedCSVFiles: fileDetails
        })

        if (!file) {
            this.setState({
                successModalType: "error",
                successMessage: "No file selected.",
                isValidAttachment: false,
                successModal: true,
            });
            return;
        }

        if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            file.type !== "application/vnd.ms-excel") {
            this.setState({
                selectedCSVFiles: {},
                successModalType: "error",
                successMessage: "Please select a valid Excel file.",
                isValidAttachment: false,
                successModal: true,
            })
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryData = e.target.result;
            const workbook = XLSX.read(binaryData, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

            this.processExcelData(sheetData);
        };

        reader.readAsBinaryString(file);
    }

    processExcelData = (sheetData) => {
        if (sheetData.length === 0) {
            this.setState({
                successModalType: "error",
                successMessage: "Excel file is empty.",
                isValidAttachment: false,
            });
            return;
        }

        const headers = sheetData[0];
        const rows = sheetData.slice(0);

        let postPeriodicalDetailsArray = [];
        let postPeriodicalHeadersArray = [];
        // let validations = this.state.validations;
        // let headersArrayObject = this.state.preRequisiteCSVHeadersForStudentMarks;

        // // Validate headers
        if (headers != undefined && headers.length > 0) {
            headers.map((headerName, index) => {
                if (headerName != undefined && headerName.trim() !== "") {
                    postPeriodicalHeadersArray.push(headerName.trim());
                }
            })
        } else {
            toast.warn("Invalid headers found in imported excel file.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

        // Read Excel Actual Body Data including date
        if (postPeriodicalHeadersArray.length > 0) {
            rows.map((csvRow, index) => {
                if (index !== 0) {
                    let resourceObject = {};

                    for (let i = 0; i < postPeriodicalHeadersArray.length; i++) {
                        let value = csvRow[i];

                        // Add the value to the resource object
                        resourceObject[postPeriodicalHeadersArray[i]] = value === undefined || value === null ? "" : value;
                    }

                    // Add the updated resource object to the final array
                    postPeriodicalDetailsArray.push({
                        ...resourceObject,
                        verificationStatus: "pending",
                        importStatus: "pending",
                        loading: false
                    });
                }
            });
        }

        this.setState({
            csvData: [...rows],
            postPeriodicalDetailsArray: postPeriodicalDetailsArray,
            postPeriodicalHeadersArray: postPeriodicalHeadersArray
        }, () => {
            this.validateCSVFileHeaders();

        })
    };

    formatDate = (dateValue) => {
        // If the value is a number (Excel timestamp), convert it to a JavaScript date
        if (typeof dateValue === 'number') {
            const excelStartDate = new Date(Date.UTC(1900, 0, 1));  // Use UTC to avoid timezone effects
            excelStartDate.setUTCDate(excelStartDate.getUTCDate() + dateValue - 2); // Adjust for the 1900 leap year bug
            return this.formatDateString(excelStartDate, "number"); // Format as YYYY-MM-DD
        }

        // If it's a string, try to parse it as a date in multiple formats
        const parsedDate = this.tryParseDate(dateValue);
        if (parsedDate) {
            return this.formatDateString(parsedDate, "string"); // Format as YYYY-MM-DD
        } else {
            return "";  // Return empty if the value is not a valid date
        }
    };

    // Helper function to try parsing the date from multiple formats
    tryParseDate = (dateValue) => {
        // Try parsing a string as an ISO date format (YYYY-MM-DD)
        let parsedDate = new Date(dateValue);
        if (parsedDate instanceof Date && !isNaN(parsedDate)) {
            return parsedDate; // Return parsed date if valid
        }

        // If it doesn't work, try parsing using a format like '10 Nov 2024'
        parsedDate = Date.parse(dateValue);
        if (!isNaN(parsedDate)) {
            return new Date(parsedDate); // Return parsed date if valid
        }

        return null;  // Return null if the date can't be parsed
    };

    // Helper function to format the date object as YYYY-MM-DD
    formatDateString = (date, type) => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        let day = '';
        if (type === "number") {
            day = String(date.getUTCDate()).padStart(2, '0');
        } else {
            day = String(date.getUTCDate() + 1).padStart(2, '0');
        }
        return `${year}-${month}-${day}`;
    };

    // CHOOSE PERIODICAL COMPONENT
    chooseFileComponent = () => {
        return (
            <>
                <div className="import-info">
                    <div className="import-info-title ">
                        <p className="import-h5">Steps to import Periodical Details:</p>
                    </div>
                    <ol className="instruction-list mt-2 mb-2">
                        <li>Periodical Details can be imported in excel format.</li>
                        <li>Excel should be in specified format for import to work correctly.</li>
                        <li>
                            Refer the below example while adding content to the excel.  &nbsp;
                            {/* onClick={() => this.props.export()} */}
                            <span className="download-links font-weight-bold" onClick={() => this.exportData()}>
                                Download Sample Excel File
                                &nbsp;<FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {this.props.csvLoading &&
                                <span> &nbsp;<FontAwesomeIcon icon={['fas', 'circle-notch']} size={'md'} className='rotate' style={{ color: '#0465AC' }} /></span>
                            }
                        </li>
                        <li>Select Institute to get Pre Requisite Data.
                            <select
                                className="form-control formControlContentTask"
                                style={{
                                    width: 'auto',
                                    height: '42px',
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    lineHeight: '20px',
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#808080',
                                    borderRadius: '7px'
                                }}
                                onChange={(e) => {
                                    let selectedIIDValue = e.target.value;
                                    this.setState({ iidPreRequisiteData: selectedIIDValue }, () => {
                                        this.apiCallToGetInstituteStreamList();  // department
                                        this.apiCallToGetAccessionSeries(); // accession series
                                        this.getPublisherList();  // publisher list
                                        this.apiCallToGetCategoryList(); // category list data
                                    })
                                }}
                                value={this.state.iidPreRequisiteData}
                            >
                                {Object.values(this.props?.multipleInstituteDetails?.multipleInstituteDetails).map((member) => (
                                    <option key={member?.iid} value={member?.iid}>
                                        {member?.institute_name}
                                    </option>
                                ))}
                            </select>
                        </li>
                        <li>Refer the prerequire data to import.
                            &nbsp;
                            {/* <CSVLink
                                onFileLoaded={this.state.preRequisiteData}
                                data={this.state.preRequisiteData}
                                id='downloadPreRequisitePostEventDetails'
                                headers={this.state.preRequisiteHeaders}
                                filename={this.state.preRequisiteFileName}
                            > */}
                            <span
                                className={`download-links font-weight-bold ${(!this.state.loadingResourceCategoryData && !this.state.loadingDepartmentData && !this.state.loadingAccessionSeriesData && !this.state.loadingPublisherDetails) ? 'download-links' : 'disabledLink'}`}
                                onClick={(periodical) => {
                                    if (
                                        !this.state.loadingResourceCategoryData &&
                                        !this.state.loadingDepartmentData &&
                                        !this.state.loadingAccessionSeriesData &&
                                        !this.state.loadingPublisherDetails
                                    ) {
                                        // Allow the download
                                        // this.downloadPrerequisitedataCSV();
                                        this.exportPreRequisiteData()
                                    } else {
                                        // Prevent the download
                                        periodical.preventDefault();
                                    }
                                }}
                            >
                                Download Prerequisite Excel File <FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {/* </CSVLink> */}
                        </li>
                    </ol>

                    <div className="import-info-preview">
                        {
                            this.state.csvData.length > 0 ? (
                                <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                    <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                        <thead>
                                            {
                                                this.state.postPeriodicalHeadersArray.map((item) => {
                                                    return (
                                                        <th>{item}</th>
                                                    )
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.postPeriodicalDetailsArray.map((item, index) => {
                                                    if (item != undefined) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    this.state.postPeriodicalHeadersArray.map((keys) => {
                                                                        if (typeof item[keys] == 'object') {
                                                                            return <td>{item[keys]['value']}</td>
                                                                        } else {
                                                                            return <td>{item[keys]}</td>
                                                                        }
                                                                    })
                                                                }

                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2">After choosing file, You can view content here.</p></span>
                        }

                    </div>

                </div>
                <div className="import-info-note mt-2 mb-3">
                    <p>Once you download the sample Excel file. Update the necessary content. In order to import the updated file you have to upload by clicking on the button mentioned below.</p>
                </div>
                <div className="import-body">
                    Select Institute to Import Resources
                    <select
                        className="form-control formControlContentTask"
                        style={{
                            width: 'auto',
                            height: '42px',
                            fontSize: "13px",
                            fontWeight: 400,
                            lineHeight: '20px',
                            fontFamily: "'Poppins', sans-serif",
                            color: '#808080',
                            borderRadius: '7px'
                        }}
                        onChange={(e) => {
                            let selectedIIDValue = e.target.value;
                            this.setState({ iidImportPeriodical: selectedIIDValue }, () => {
                                this.ImportapiCallToGetAccessionSeries(); // accession series
                                this.ImportgetPublisherList();  // publisher list 
                            })
                        }}
                        value={this.state.iidImportPeriodical}
                    >
                        {Object.values(this.props?.multipleInstituteDetails?.multipleInstituteDetails).map((member) => (
                            <option key={member?.iid} value={member?.iid}>
                                {member?.institute_name}
                            </option>
                        ))}
                    </select>
                    <div className="d-flex align-items-center flex-wrap">
                        <div style={{ display: "none" }}>
                            <form ref={this.myRef}>
                                <input
                                    type="file"
                                    id="react-excel-reader-input-periodical"
                                    accept=".xlsx, .xls"
                                    onChange={this.handleExcelInput}
                                    style={{ display: 'none' }}
                                />
                            </form>
                            {/* <CSVReader
                                cssClass="csv-reader-input"
                                label="Select CSV file"
                                onFileLoaded={this.handleCSVInput}
                                parserOptions={papaparseOptions}
                            /> */}
                        </div>
                        <button type="button" className="btn import-btn" onClick={this.openFileInput}>
                            <FontAwesomeIcon icon={['fas', 'paperclip']} size={'lg'} color={"#FFF"}></FontAwesomeIcon> Choose File
                        </button>
                        {
                            Object.keys(this.state.selectedCSVFiles).length > 0 ?
                                <span>
                                    <span>
                                        {this.state.selectedCSVFiles['name']}
                                        <span style={{ "cursor": 'pointer' }} onClick={() => {
                                            this.removeCSVFile()
                                            this.myRef.current.reset()
                                        }}>
                                            <FontAwesomeIcon icon={['fas', 'times']} size={'md'}></FontAwesomeIcon>
                                        </span>
                                    </span>
                                </span>
                                : <p className="mb-0"><span className="text-danger">*</span> Please choose your excel file to import periodical details</p>
                        }
                    </div>
                </div>
                {
                    this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                    <div className="alert alert-danger" style={{ maxHeight: '20vh', overflow: "auto" }}>
                        {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                                return <p className="text-danger my-2">Header {item.cell}-{item.message}</p>
                            })
                        }
                    </div>
                }
            </>
        )
    }

    // IMPORT CSV FILE COMPONENT 
    importCSVFileComponent = () => {
        return (
            <>
                <div className="previw-sheet" style={{ minHeight: '40vh' }}>
                    {
                        this.state.csvData.length > 0 ? (
                            <div className="table-responsive" >
                                <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                    <thead>
                                        <th className="td-dense">{"Sr. No."}</th>
                                        <th className="td-dense">{"Status"}</th>
                                        {/* {this.state.currentProgress == 0 ? "Error Location" : } */}
                                        {
                                            this.state.postPeriodicalHeadersArray.map((item) => {
                                                return (
                                                    <th className="td-dense">
                                                        {item === 'Title' ? (
                                                            <>
                                                                {item} <span className="text-danger">*</span>
                                                            </>
                                                        ) : (
                                                            item
                                                        )}
                                                    </th>
                                                )
                                            })
                                        }
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.postPeriodicalDetailsArray.map((item, index) => {
                                                if (item != undefined) {
                                                    return (

                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td className="td-dense">
                                                                {
                                                                    this.getCurrentStatusComponent(index, item['verificationStatus'], item['importStatus'])
                                                                }
                                                            </td>

                                                            {
                                                                this.state.postPeriodicalHeadersArray.map((keys, cellIndex) => {
                                                                    let itemValues = [];
                                                                    if (typeof item[keys] === 'string') {
                                                                        // If it's a string, split it by commas
                                                                        itemValues = item[keys].split(',').map(val => val.trim());
                                                                    } else if (Array.isArray(item[keys])) {
                                                                        // If it's already an array, just use it
                                                                        itemValues = item[keys];
                                                                    }

                                                                    const options = itemValues.map(value => ({
                                                                        value: value,
                                                                        label: value, // or any other custom label format
                                                                    }));

                                                                    let selectedData = item['Publisher'] ? Object.entries(this.state.ImportpublisherDataList)
                                                                        .filter(([publisherId, publisher]) => itemValues.includes(publisher.name))
                                                                        .map(([publisherId, publisher]) => ({
                                                                            value: publisherId,
                                                                            label: publisher.name
                                                                        })) : [];

                                                                    const selectedOption = options.filter(option => itemValues.includes(option.value));

                                                                    return (
                                                                        <td className={this.state.currentErrorObject['row'] == index ? "td-dense-highlight" : "td-dense"}>
                                                                            <div className={this.state.currentErrorObject['row'] == index ? "table-row-highlighter" : ""}>
                                                                                {keys == 'Publisher' ?
                                                                                    <>
                                                                                        <Select
                                                                                            isMulti
                                                                                            options={Object.entries(this.state.ImportpublisherDataList).map(([seriesId, seriesData]) => ({
                                                                                                value: seriesId,
                                                                                                label: seriesData?.name,
                                                                                            }))}
                                                                                            value={selectedData}
                                                                                            onChange={(e) => {
                                                                                                this.getValueOfMultipleSelect(index, keys, e);
                                                                                            }}
                                                                                            isSearchable
                                                                                            onInputChange={(inputValue) => {
                                                                                                this.setState({ searchPublisher: inputValue }, () => {
                                                                                                    this.getPublisherList(); // Trigger the API call after updating the search term
                                                                                                }, 200);
                                                                                            }}
                                                                                            className='basic-multi-select'
                                                                                            // Apply custom styles to the dropdown
                                                                                            styles={{
                                                                                                control: (base) => ({
                                                                                                    ...base,
                                                                                                    width: '100%',
                                                                                                    minHeight: 42, // Minimum height for the control area
                                                                                                    height: 'auto', // Allow control to grow dynamically
                                                                                                }),
                                                                                                menu: (base) => ({
                                                                                                    ...base,
                                                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                                                }),
                                                                                                menuPortal: (base) => ({
                                                                                                    ...base,
                                                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                                                }),
                                                                                                placeholder: (base) => ({
                                                                                                    ...base,
                                                                                                    fontSize: '12px',
                                                                                                    fontWeight: 400,
                                                                                                }),
                                                                                                option: (base, state) => ({
                                                                                                    ...base,
                                                                                                    fontSize: '12px',
                                                                                                    fontWeight: 400,
                                                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                                                    color: state.isSelected ? '#333' : '#555',
                                                                                                }),
                                                                                                singleValue: (base) => ({
                                                                                                    ...base,
                                                                                                    fontSize: '12px',
                                                                                                    fontWeight: '400',
                                                                                                }),
                                                                                            }}
                                                                                            // Specify that the menu should be rendered in the document body
                                                                                            menuPortalTarget={document.body}
                                                                                        />
                                                                                        <span>{item['Publisher'] ? null : `Invalid ${keys}`}</span>
                                                                                    </> : keys == 'Accession Series' ?
                                                                                        <>
                                                                                            <select
                                                                                                id="series-selction"
                                                                                                value={item[keys]} // Set the selected value
                                                                                                className="form-control"
                                                                                                onChange={(e) => {
                                                                                                    this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                                }}
                                                                                                style={{
                                                                                                    width: "max-content"
                                                                                                }}
                                                                                            >
                                                                                                <option value="">{item[keys] ? `Select ${keys}` : keys}</option>
                                                                                                {
                                                                                                    Object.values(this.state.ImportaccessionSeriesList).map((data) => {
                                                                                                        const label = data.label.length > 20 ? data.label.slice(0, 20) + '...' : data.label;
                                                                                                        return (
                                                                                                            <option key={data.value} value={data.label} title={data.label}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }
                                                                                            </select>
                                                                                            <span>{item['Accession Series'] ? null : `Invalid ${keys}`}</span>
                                                                                        </>
                                                                                        : <input
                                                                                            type='text'
                                                                                            placeholder={`Enter ${keys}`}
                                                                                            value={item[keys]}
                                                                                            ref={(el) => this.tableObject[`${index}-${cellIndex}`] = el}
                                                                                            style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                                                            className="form-control filterInput"
                                                                                            onChange={(e) => {
                                                                                                this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                            }}
                                                                                        />}
                                                                            </div>
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                }
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        ) : <p>Data is not available.</p>
                    }
                </div>
                <p><span className="text-danger my-2 font-size14">*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them. </p>

                <div className="inspect-console">
                    <div className="table-responsive">
                        <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        <div className="import-progress">
                                            {
                                                this.state.importProgress.map((item, index) => {
                                                    return (
                                                        <div className="tab-wrapper">
                                                            <div className="step-wrapper">
                                                                <span className={this.state.currentProgress == index ? "circle-tab" : "circle-tab-muted"} style={this.checkImportTabProgress(index) ? { background: "green", color: "#FFF" } : {}}>{index + 1}</span>
                                                                {index < this.state.importProgress.length - 1 && <span className={this.state.validations['isVerified'] ? "step-line bg-success" : "step-line "}></span>}
                                                            </div>
                                                            <p className={this.state.currentProgress == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p>
                                                        </div>

                                                    )
                                                })
                                            }
                                        </div>
                                    </th>

                                    <th>
                                        <div className="d-flex justify-content-between align-items-center" >
                                            <span onClick={() => {
                                                this.state.currentPointer > 0 && this.navigateToPreviousError()
                                            }} disabled={true} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-left']} size="md"></FontAwesomeIcon></span>
                                            <p className="mb-0 font-weight-bold">Error Location :
                                                {Object.keys(this.state.currentErrorObject).length > 0 &&
                                                    `Rows : ${this.state.currentErrorObject['row'] + 1} Columns : ${this.state.currentErrorObject['key']}`
                                                }
                                            </p>
                                            <span onClick={() => {
                                                this.state.currentPointer < this.state.errorLogs.length && this.navigateToNextError()
                                            }} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-right']} size="md"></FontAwesomeIcon></span>
                                        </div>
                                    </th>
                                </tr>
                                <tr>

                                    <th align="center" style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        {
                                            this.state.errorLogs.length > 0 ?
                                                (
                                                    <div>{this.ErrorViewConsole()}</div>
                                                )
                                                : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2 mb-0">After verification, You can view content which has errors.</p></span>
                                        }
                                        {/* 
										{
											this.state.errorMessageObjArray?.length > 0 ?
												this.state.errorMessageObjArray?.map((row) => {
													let rowIndex = row['rowIndex'];
													let message = row['message'];
													return <div>Row : {rowIndex} | Error : {message}</div>;
												})
												:
												<span className="initial-preview">
													<FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999" />
													<p className="mx-2 mb-0">After verification, You can view content which has errors.</p>
												</span>
										} */}

                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </>
        )
    }

    // 	GET CURRENT STATUS COMPONENT
    getCurrentStatusComponent = (index, verificationStatus = "pending", importStatus = "pending") => {
        {
            return this.state.importPointer['rowindex'] == index ?
                <div>
                    {
                        this.state.importPointer['loading'] ?
                            <div class="spinner-border spinner-border-sm" role="status" >
                                <span class="sr-only">{this.state.importPointer['status']}...</span>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>{this.state.importPointer['status']}</div>
                                {
                                    this.state.importPointer['status'] == 'failed' &&
                                    // importStatus == 'failed' &&
                                    <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                                        this.setState({
                                            loadingImportProcess: true
                                        }, () => {
                                            this.apiCallToImportPeriodicalDetails(index, this.state.importProgressSummary, 'true')
                                        })
                                    }>
                                        Retry
                                    </button>
                                }
                            </div>

                    }

                </div>

                : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div>{importStatus}</div>

                    {
                        // this.state.importPointer['status'] == 'failed' &&
                        importStatus == 'failed' &&
                        <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                            this.setState({
                                loadingImportProcess: true
                            }, () => {
                                this.apiCallToImportPeriodicalDetails(index, this.state.importProgressSummary, 'true')
                            })
                        }>
                            Retry
                        </button>
                    }
                </div>
        }
    }

    //function to download prerequisite data 
    downloadPrerequisitedataCSV = () => {
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        // For Department
        if (Object.values(this.state.GetStreamList).length > 0) {
            Object.keys(this.state.GetStreamList).map((stream, index) => {
                let branch = this.state.GetStreamList[stream]
                if (branch != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].branch = branch.name
                    } else {
                        preRequisiteData.push({ periodicity: '', category: '', department: branch.name })
                    }
                }
            })
        }

        // For categoryList
        if (Object.values(this.state.categoryList).length > 0) {
            Object.keys(this.state.categoryList).map((Id, index) => {
                let category = this.state.categoryList[Id]
                if (category != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].category = category.category_name
                    } else {
                        preRequisiteData.push({ periodicity: '', category: category.category_name, department: '' })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }
    // Strip HTML
    stripHtml(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //FUNCTION DEFINED TO GET THE INPUT OF THE IMPORTED CSV
    handleCSVInput = (csvData, fileInformation) => {

        this.setState({
            selectedCSVFiles: fileInformation
        })

        if (fileInformation.type !== "text/csv") {
            this.setState({
                selectedCSVFiles: {},
                successModal: true,
                successModalType: "error",
                successMessage: "Please select csv file.",
                isValidAttachment: false
            })
        } else {
            let postPeriodicalDetailsArray = [];
            let postPeriodicalHeadersArray = [];

            if (csvData.length > 0) {
                csvData = csvData.filter((rowArray, index) => rowArray.length > 1 && !rowArray.every((val) => val == ""));

                // Read CSV Headers
                let headers = csvData[0];

                if (headers != undefined && headers.length > 0) {
                    headers.map((headerName, index) => {
                        if (headerName != undefined) {
                            postPeriodicalHeadersArray.push(headerName.trim());
                        }
                    })
                }

                // Read CSV Actual Body Data
                if (postPeriodicalHeadersArray.length > 0) {
                    csvData.map((csvRow, index) => {
                        if (index != 0) {
                            let challanObject = {};
                            let totalDeduction = 0;

                            for (let i = 0; i < postPeriodicalHeadersArray.length; i++) {

                                if (csvRow[i] == undefined || csvRow[i] == null || csvRow[i] == "") {
                                    challanObject[postPeriodicalHeadersArray[i]] = "";
                                } else {
                                    challanObject[postPeriodicalHeadersArray[i]] = csvRow[i];
                                }
                            }

                            if (challanObject['Gross Pay'] != undefined) {
                                challanObject['Net Pay'] = parseFloat(challanObject['Gross Pay']) - totalDeduction;
                            }

                            postPeriodicalDetailsArray.push({ ...challanObject, verificationStatus: "pending", importStatus: "pending", loading: false });
                        }
                    })
                }
            }

            this.setState({
                csvData: [...csvData],
                postPeriodicalDetailsArray: postPeriodicalDetailsArray,
                postPeriodicalHeadersArray: postPeriodicalHeadersArray
            }, () => {
                this.validateCSVFileHeaders();

            })
        }
    }

    // VALIDATE CSV FILE HEADERS
    validateCSVFileHeaders = () => {
        let commonHeaders = ["Title*", "Publisher", "ISSN Number", "Accession Series", "Accession Number", "Periodical Category", "Periodicity", "Department"]
        let mandatoryHeaders = ["Title*"]
        let postPeriodicalHeadersArray = this.state.postPeriodicalHeadersArray;
        let validations = this.state.validations;

        if (postPeriodicalHeadersArray.length > 0) {
            // Checking Default periodical Headers are available or not.
            mandatoryHeaders.map((header, index) => {
                if (!postPeriodicalHeadersArray.includes(header)) {
                    let validationObject = {
                        touch: true,
                        cell: index + 1,
                        row: 0,
                        status: "error",
                        message: `${header} is mandatory column to import periodical.`,
                        type: "header",
                        errorCount: 0
                    }
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }
            })

            // Checking Dyanamic periodical Headers are available or not.
            postPeriodicalHeadersArray.map((key, index) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    status: "error",
                    message: "",
                    type: "header",
                    errorCount: 0
                }

                let isValidHeader = commonHeaders.some((keys) => {
                    return keys == key.trim();
                })

                if (!isValidHeader) {
                    validationObject.cell = index;
                    validationObject.status = "error";
                    validationObject.message = `Please check default headers. ${key} header is invalid.`;
                    validationObject.touch = true;
                }


                if (validationObject.touch) {
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }

            })
        }


        if (validations['headersErrors'].length == 0) {
            validations['isHeadersValid'] = true;
        }

        this.setState({
            validations: { ...validations }
        })
    }

    // VALIDATE CSV FILE DATA
    validateCSVFileData = () => {
        let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
        let postPeriodicalHeadersArray = this.state.postPeriodicalHeadersArray;
        let validations = { ...this.state.validations, dataErrors: {}, errors: [], isDataValid: false, isVerified: false };
        let verificationSummary = {
            completed: 0,
            failed: 0,
            total: 0,
            pending: 0
        };

        verificationSummary['total'] = postPeriodicalDetailsArray.length;
        verificationSummary['pending'] = postPeriodicalDetailsArray.length;
        let verificationPointer = this.state.verificationPointer;

        postPeriodicalDetailsArray.map((item, rowIndex) => {
            let status = true;
            let hasEarning = true;
            verificationPointer['loading'] = true;
            verificationPointer['status'] = 'verfying';
            verificationPointer['rowindex'] = rowIndex;
            this.setState({
                verificationPointer: verificationPointer
            })

            verificationSummary['pending'] -= verificationSummary['pending'];

            postPeriodicalHeadersArray.map((key, cellIndex) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "",
                    type: "data",
                    errorCount: 0
                }

                if (validationObject.touch) {
                    status = false;
                    if (validations['dataErrors'][rowIndex] == undefined) {
                        validations['dataErrors'][rowIndex] = {};
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;

                    } else {
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;
                    }
                    item['verificationStatus'] = "failed";
                    validations['isDataValid'] = false;
                }
            })

            if (hasEarning) {
                validations['errors'].push({
                    touch: true,
                    cell: 0,
                    row: rowIndex,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "Please enter atleast one earning component",
                    type: "basic",
                    errorCount: 1
                })

                verificationPointer['status'] = 'failed';
                postPeriodicalDetailsArray[rowIndex]['verificationStatus'] = 'failed';
                verificationPointer['loading'] = false;
            } else {
                verificationPointer['status'] = status ? 'verified' : 'failed';
                postPeriodicalDetailsArray[rowIndex]['verificationStatus'] = verificationPointer['status'];
                verificationPointer['loading'] = false;
            }

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];

            this.setState({
                postPeriodicalDetailsArray: [...postPeriodicalDetailsArray],
                verificationProgress: verificationSummary,
                verificationPointer: verificationPointer,
            })
        })

        if (validations['errors'].length > 0) {
            let failedCount = 0;
            validations['errors'].map(item => {
                if (!Object.keys(validations['dataErrors']).includes(item.row)) {
                    failedCount++;
                }
            })

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length + failedCount;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];
        }


        if (Object.keys(validations['dataErrors']).length == 0 && validations['errors'].length == 0) {
            validations['isDataValid'] = true;
            validations['isVerified'] = true;
            this.setState({
                currentPointer: 1
            })
        }

        this.setState({
            validations: { ...validations },
            verificationProgress: verificationSummary,
            loadingVerificationProcess: false
        }, () => {
            this.getBugLogs();
        })
    }

    // GET VALUES FORM INPUT FIELDS
    getValueOfRowInputs = (rowIndex, key, value, type) => {
        let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
        let rowObject = postPeriodicalDetailsArray[rowIndex];
        if (typeof rowObject[key] == 'object') {
            rowObject[key]['value'] = value;
        } else {
            rowObject[key] = value;
        }

        postPeriodicalDetailsArray[rowIndex] = rowObject;

        this.setState({
            postPeriodicalDetailsArray: postPeriodicalDetailsArray
        })
    }

    // GET VALUES FORM Multi-Select FIELDS
    getValueOfMultipleSelect = (rowIndex, key, selectedOptions) => {
        let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
        let rowObject = postPeriodicalDetailsArray[rowIndex];

        // If the selected options are not empty, update the row object with the selected values
        if (selectedOptions && selectedOptions.length > 0) {
            rowObject[key] = selectedOptions.map(option => option.label); // Set selected values as an array
        } else {
            rowObject[key] = []; // If no options are selected, set it to an empty array
        }

        postPeriodicalDetailsArray[rowIndex] = rowObject;

        this.setState({
            postPeriodicalDetailsArray: postPeriodicalDetailsArray
        });
    }

    // Navigate to previous 
    navigateToPreviousError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer > 0) {
            currentPointer -= 1;
            currentErrorObject = errorLogs[currentPointer];
            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }

    }

    // Navigate to next
    navigateToNextError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer < errorLogs.length - 1) {

            currentPointer += 1;
            currentErrorObject = errorLogs[currentPointer];

            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }
    }

    // CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    // CONSOLE ERROR 
    ErrorViewConsole = () => {
        let { row, message } = this.state.currentErrorObject;
        return (
            <div>
                {
                    this.state.currentErrorObject['key'] != "" && (
                        <div>
                            <p className="mb-0 font-weight-bold text-danger">{this.state.currentErrorObject['message']}</p>
                        </div>
                    )

                }
            </div>
        )
    }

    // API CALL TO IMPORT Periodical
    apiCallToImportPeriodicalDetails = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {
        this.setState({ importPeriodicalLoading: true })

        let errorMessageObjArray = this.state.errorMessageObjArray;

        if (rowIndex < this.state.postPeriodicalDetailsArray.length) {
            let periodicalData = this.state.postPeriodicalDetailsArray[rowIndex];
            let importPointer = this.state.importPointer;
            importPointer['loading'] = true;
            importPointer['status'] = 'importing';
            importPointer['rowindex'] = rowIndex;
            this.setState({
                importPointer: importPointer,
            })

            let errorLogs = this.state.errorLogs;
            let itemValues = [];
            if (typeof periodicalData['Publisher'] === 'string') {
                // If it's a string, split it by commas
                itemValues = periodicalData['Publisher'].split(',').map(val => val.trim());
            } else {
                itemValues = periodicalData['Publisher']
            }

            let accessionSeriesValues = [];
            if (typeof periodicalData['Accession Series'] === 'string') {
                // If it's a string, split it by commas
                accessionSeriesValues = periodicalData['Accession Series'].split(',').map(val => val.trim());
            } else {
                accessionSeriesValues = periodicalData['Accession Series']
            }

            let selectedData = Object.entries(this.state.ImportpublisherDataList)
                .filter(([publisherId, publisher]) => itemValues.includes(publisher.name))
                .map(([publisherId, publisher]) => ({
                    value: publisherId,
                    label: publisher.name
                }));

            let selectedAccessionSeries = this.state.ImportaccessionSeriesList.filter(item => accessionSeriesValues.includes(item.label));

            let selectedPublisherIds = selectedData.map(item => item.value);

            let selectedAccessionSeriesIds = selectedAccessionSeries.map(item => item.value);

            let title = periodicalData['Title*'];
            let category = periodicalData['Periodical Category'];
            let departments = periodicalData['Department'];
            let Publisher = selectedPublisherIds;
            let issnNumber = periodicalData['ISSN Number'];
            let periodicity = periodicalData['Periodicity'];
            let accessionSeriesId = selectedAccessionSeriesIds[0];
            let accessionNumber = periodicalData['Accession Number'];

            let requestData = {
                "title": title,
                "instituteId": this.state.iidImportPeriodical, // config.institute_id,
                "category": category,
                "Publisher": Publisher,
                "issnNumber": issnNumber,
                "periodicity": periodicity,
                "departments": departments,
                "facultyId": config.faculty_id,
                "accessionSeriesId": accessionSeriesId,
                "accessionNumber": accessionNumber
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_importPeriodicalDetails',
                requestData,
                "/api/library/libraryPeriodicals.php"
            );

            if (jsonResponse.expired) {

                setTimeout(() => {
                    this.apiCallToImportPeriodicalDetails(rowIndex, importProgressSummary, isRetry);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == 'success') {
                        let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
                        let rowItem = postPeriodicalDetailsArray[rowIndex];
                        rowItem['status'] = 'completed'
                        postPeriodicalDetailsArray[rowIndex] = rowItem;

                        importProgressSummary['completed'] += 1;
                        if (isRetry != "true") {

                            importProgressSummary['pending'] -= 1;
                        } else {
                            importProgressSummary['failed'] -= 1;
                        }

                        importPointer['status'] = 'success';
                        postPeriodicalDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;


                        let findIndex = errorLogs.findIndex(obj => obj.row == rowIndex)

                        if (findIndex != -1) {
                            errorLogs.splice(findIndex, 1);
                        }


                        this.setState({
                            postPeriodicalDetailsArray: postPeriodicalDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentPointer: 0,
                            currentErrorObject: errorLogs.length > 0 ? errorLogs[0] : {}
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportPeriodicalDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                    else {
                        this.setState({ importPeriodicalLoading: false })
                        // let rowIndex = rowIndex + 1;
                        let errorObj = {};
                        errorObj['row'] = rowIndex;
                        errorObj['key'] = apiResult.key;
                        errorObj['message'] = apiResult.message;

                        // errorLogs.push(errorObj);

                        let foundIndex = errorLogs.findIndex(obj => obj.row == rowIndex);
                        if (foundIndex != -1) {
                            errorLogs[foundIndex] = errorObj;
                        }
                        else {
                            errorLogs.push(errorObj);
                        }

                        // currentErrorObject['rowIndex'] = rowIndex + 1;
                        // currentErrorObject['key'] = apiResult.key;
                        // currentErrorObject['message'] = apiResult.message;
                        let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
                        let rowItem = postPeriodicalDetailsArray[rowIndex];
                        rowItem['status'] = 'failed';
                        postPeriodicalDetailsArray[rowIndex] = rowItem;
                        if (isRetry != "true") {
                            importProgressSummary['failed'] += 1;
                            importProgressSummary['pending'] -= 1;
                        }

                        importPointer['status'] = 'failed';

                        postPeriodicalDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;

                        this.setState({
                            postPeriodicalDetailsArray: postPeriodicalDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentErrorObject: errorLogs[0],
                            currentPointer: 0,
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportPeriodicalDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                } else {
                    let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
                    importProgressSummary['failed'] += 1;
                    importPointer['status'] = 'failed';
                    postPeriodicalDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                    importPointer['loading'] = false;

                    this.setState({
                        postPeriodicalDetailsArray: postPeriodicalDetailsArray,
                        importProgressSummary: importProgressSummary,
                        importPointer: importPointer,
                        currentPointer: 0,
                    }, () => {

                        if (isRetry != "true") {

                            this.apiCallToImportPeriodicalDetails(rowIndex + 1, importProgressSummary, isRetry);
                        }
                    })

                }
            }

        } else {
            this.setState({
                loadingImportProcess: false
            })
        }
    }

    checkImportStatus = () => {
        return this.state.postPeriodicalDetailsArray.some((item, index) => item.importStatus == 'success')
    }

    checkImportTabProgress = (index) => {
        if (index == 0) {
            return this.state.validations['isVerified']
        } else if (index == 1) {
            return this.checkImportStatus()
        }
    }

    render() {
        return (
            <>
                {/* <FontAwesomeIcon size='sm' style={{ color: '#0465AC', cursor: 'pointer' }} title="Click here to import" icon={["fa", "file-import"]} onClick={this.openImportPeriodicalModal} /> */}


                {this.importPeriodicalModal()}
                <div id="exportList"></div>
                <SuccessModal
                    successModal={this.state.successModal}
                    successModalType={this.state.successModalType}
                    successMessage={this.state.successMessage}
                    closeSuccessModal={this.closeSuccessModal}
                />

            </>
        )
    }
}

const ProgressBar = (props) => {
    const { bgcolor, completed, failed, pending, total } = props;

    let pendingProgressWidth = (pending / total) * 100;
    let completedProgressWidth = (completed / total) * 100;
    let failedProgressWidth = (failed / total) * 100;


    const containerStyles = {
        // height: 15,
        width: '100%',
        backgroundColor: "#e0e0de",
        margin: '0.2em 0',
        display: 'flex',

    }

    const fillerStyles = {
        height: '100%',
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: 'width 1s ease-in-out',
    }

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    }
    const completedProgress = {
        width: `${completedProgressWidth}%`,
        backgroundColor: 'green'
    }


    const failedProgress = {
        width: `${failedProgressWidth}%`,
        backgroundColor: 'tomato'
    }

    const pendingProgress = {
        width: `${pendingProgressWidth}%`,
        backgroundColor: 'orange'
    }
    return (
        <div style={containerStyles}>
            {
                total > 0 && (<>
                    <div style={{ ...fillerStyles, ...completedProgress }}>
                        <span style={labelStyles}>{`${completedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...failedProgress }}>
                        <span style={labelStyles}>{`${failedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...pendingProgress }}>
                        <span style={labelStyles}>{`${pendingProgressWidth}%`}</span>
                    </div>
                </>)
            }

        </div>
    );
};


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET admin DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};

export default connect(mapStateToProps)(ImportPeriodicals);